
import { Button } from "@/components/ui/button";

interface FormSubmitButtonProps {
  isSubmitting: boolean;
  membershipType: "active" | "benefactor" | "donor";
  donationAmount?: number;
}

export function FormSubmitButton({ 
  isSubmitting, 
  membershipType, 
  donationAmount = 0 
}: FormSubmitButtonProps) {
  console.log("RENDER: FormSubmitButton with membershipType:", membershipType);
  
  const buttonText = membershipType === "donor"
    ? `Faire un don de ${donationAmount}€`
    : "Adhérer";

  return (
    <Button 
      type="submit" 
      className="bg-[#00123A] hover:bg-[#00123A]/80 text-white px-10 py-2"
      disabled={isSubmitting}
    >
      {isSubmitting ? "Traitement en cours..." : buttonText}
    </Button>
  );
}
